import NotFound from "../pages/NotFound";
import AboutUs from "../pages/about/page";
import PaymentCallback from "../pages/callback/page";
import Home from "../pages/home/page";

const routes = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <AboutUs />,
  },
  {
    path: "/callback",
    element: <PaymentCallback />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
